import React from "react";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, useTheme } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { IRaDetailView } from "../../models/models";
import { ExpandMore } from "@mui/icons-material";
import { FormTextField } from "../../common/form-fields-wrappers";

const DriversInfo = () => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();

    const raDetailForm = useFormContext<IRaDetailView>();
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"bodyLarge"}>
                    {t("raDetail.driversInfo.accordion.title")}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Typography variant={"bodyLarge"}>
                    {t("raDetail.driversInfo.accordion.subtitle.mainDriver")}
                </Typography>

                <Grid container columnSpacing={2} sx={{mb: theme.spacing(2)}}>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='driversInfo.mainDriver.firstName'
                            control={raDetailForm.control}
                            label={t("raDetail.driversInfo.form.label.firstName")}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='driversInfo.mainDriver.lastName'
                            control={raDetailForm.control}
                            label={t("raDetail.driversInfo.form.label.lastName")}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='driversInfo.mainDriver.mobile'
                            control={raDetailForm.control}
                            label={t("raDetail.driversInfo.form.label.mobile")}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='driversInfo.mainDriver.email'
                            control={raDetailForm.control}
                            label={t("raDetail.driversInfo.form.label.email")}
                            fullWidth
                            disabled
                        />
                    </Grid>
                </Grid>

                {
                    raDetailForm.getValues('driversInfo.additionalDrivers')
                        .map((driver: any, index: number) =>
                            <Box key={"additionalDriver_" + index}>
                                <Typography variant={"bodyLarge"}>
                                    {t("raDetail.driversInfo.accordion.subtitle.additionalDriver")}
                                </Typography>
                                <Grid container columnSpacing={2} key={"additionalDriverInfo-" + index} sx={{mb: theme.spacing(2)}}>
                                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                        <FormTextField<IRaDetailView>
                                            name={`driversInfo.additionalDrivers.${index}.firstName`}
                                            control={raDetailForm.control}
                                            label={t("raDetail.driversInfo.form.label.firstName")}
                                            fullWidth
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                        <FormTextField<IRaDetailView>
                                            name={`driversInfo.additionalDrivers.${index}.lastName`}
                                            control={raDetailForm.control}
                                            label={t("raDetail.driversInfo.form.label.lastName")}
                                            fullWidth
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                        <FormTextField<IRaDetailView>
                                            name={`driversInfo.additionalDrivers.${index}.mobile`}
                                            control={raDetailForm.control}
                                            label={t("raDetail.driversInfo.form.label.mobile")}
                                            fullWidth
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                        <FormTextField<IRaDetailView>
                                            name={`driversInfo.additionalDrivers.${index}.email`}
                                            control={raDetailForm.control}
                                            label={t("raDetail.driversInfo.form.label.email")}
                                            fullWidth
                                            disabled
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        )
                }
            </AccordionDetails>
        </Accordion>
    );
}

export default DriversInfo;